module.exports = __webpack_public_path__ + "img/re_experiences.28b4c9e2.png";